const menu = [
  {
    id: 1,
    title: 'Cart',
    url: 'https://cart-pv.netlify.app/',
    img: './images/item-11.png',
    desc: `Simple cart site used React to create it.`,
  },
  {
    id: 10,
    title: 'Coctails',
    url: 'https://coctails-pv.netlify.app',
    img: './images/item-10.png',
    desc: `Coctail site , as it say's that has coctails but also react rotter and coctail DB.`,
  },
  {
    id: 12,
    title: 'VOLO',
    url: 'https://volo-pv.netlify.app/',
    img: './images/12.png',
    desc: `Project made for my school, created with Bootstrap, html , css , JavaScript.`,
  },
  {
    id: 9,
    title: 'Strip clone',
    url: 'https://stripe-pv.netlify.app/',
    img: './images/item-9.png',
    desc: `Strip site is so cool so i decide to clone it without animation and other stuffs.`,
  },
  {
    id: 7,
    title: 'Color Generator',
    url: 'https://color-pv.netlify.app',
    img: './images/item-7.png',
    desc: `This is cool site for finding your perfect percent of your color.`,
  },
  {
    id: 3,
    title: 'Menu',
    url: 'https://menu-pv.netlify.app',
    img: './images/item-3.png',
    desc: `Menu site for restorans it has Category's where when you add something it automatlly update new category and render it.`,
  },
  {
    id: 13,
    title: 'Wordpress two and a half man',
    url: 'https://twoandhalfmanblog.wordpress.com/',
    img: './images/13.png',
    desc: `Project made for my school, created with only Wordpress.`,
  },
  {
    id: 2,
    title: 'Tour',
    url: 'https://tours-pv.netlify.app',
    img: './images/item-2.png',
    desc: `Simple site for tour, just a preview of places where to go and price, with little description.`,
  },
  {
    id: 4,
    title: 'Person review',
    url: 'https://person-reviev-pv.netlify.app',
    img: './images/item-4.png',
    desc: `Review Person with description, position, random button. `,
  },
  {
    id: 6,
    title: 'Lorem ipsum Generator',
    url: 'https://lorem-pv.netlify.app',
    img: './images/item-6.png',
    desc: `As every designer/programmer that uses Lorem i created automatic lorem generator up to 9 paragraph of text. `,
  },
  {
    id: 8,
    title: 'Grocery',
    url: 'https://grocery-pv.netlify.app',
    img: './images/item-8.png',
    desc: `Site for making your own grocery list.`,
  },
  {
    id: 5,
    title: 'Slider',
    url: 'https://slider-pv.netlify.app',
    img: './images/item-5.png',
    desc: `Automatic slider with cool animation and preview of each person. `,
  },
  {
    id: 10,
    title: 'Birth day',
    url: 'https://birthday-pv.netlify.app',
    img: './images/item-1.png',
    desc: `Start up site from where i begin to code in React and other language.`,
  },
]
export default menu
